export default "__VITE_ASSET__C61t7UuA__"